import type { KnownPlatforms } from "@asurion-core/eventualize";
import type { Channel } from "@expert/shared-types";

const PLATFORM_BY_CHANNEL: Record<Channel, KnownPlatforms> = { voice: "ExWo", chat: "REPlatform" };

/**
 * Voice and chat report to different analytics platforms, and one build now serves both, so the
 * build's ExWo/REPlatform value follows the runtime channel. Other platforms (e.g. ExWoSaaS) are kept.
 */
export function analyticsPlatformForChannel(buildPlatform: KnownPlatforms, channel: Channel): KnownPlatforms {
    const isChannelPlatform = Object.values(PLATFORM_BY_CHANNEL).includes(buildPlatform);
    return isChannelPlatform ? PLATFORM_BY_CHANNEL[channel] : buildPlatform;
}
